import React, { useEffect, useState } from 'react';
import { AlertCircle, CheckCircle, Info, XCircle } from 'lucide-react';

const Message = ({ type, message, duration = 5000, showIcon = true }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    
    if (duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [duration]);

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircle size={16} />;
      case 'error':
        return <XCircle size={16} />;
      case 'warning':
        return <AlertCircle size={16} />;
      default:
        return <Info size={16} />;
    }
  };

  return (
    <div className={`message ${type} ${isVisible ? 'visible' : ''}`}>
      {showIcon && (
        <div className="message-icon">
          {getIcon()}
        </div>
      )}
      <div className="message-content">{message}</div>

      <style jsx>{`
        .message {
          display: flex;
          align-items: center;
          gap: 10px;
          background: rgba(23, 42, 69, 0.9);
          border-radius: 8px;
          padding: 12px 16px;
          margin-bottom: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          border: 1px solid rgba(231, 76, 60, 0.2);
          transform: translateY(-10px);
          opacity: 0;
          transition: all 0.3s ease;
          max-width: 400px;
        }
        
        .message.visible {
          transform: translateY(0);
          opacity: 1;
        }
        
        .message.success {
          border-left: 3px solid #2ecc71;
        }
        
        .message.error {
          border-left: 3px solid #e74c3c;
        }
        
        .message.warning {
          border-left: 3px solid #f39c12;
        }
        
        .message.info {
          border-left: 3px solid #3498db;
        }
        
        .message-icon {
          color: #e74c3c;
        }
        
        .message.success .message-icon {
          color: #2ecc71;
        }
        
        .message.error .message-icon {
          color: #e74c3c;
        }
        
        .message.warning .message-icon {
          color: #f39c12;
        }
        
        .message.info .message-icon {
          color: #3498db;
        }
        
        .message-content {
          color: white;
          font-size: 14px;
          line-height: 1.4;
          font-weight: 500;
        }
        
        @media (max-width: 576px) {
          .message {
            padding: 10px 12px;
            font-size: 13px;
          }
        }
      `}</style>
    </div>
  );
};

export default Message;